import React, { Component } from 'react'
import { Table, Header, Segment, Tab, Select, Form } from 'semantic-ui-react';
import MaterialTable, { MTableToolbar } from 'material-table'

import { Row, Col, Input } from "reactstrap";
import Parse from 'widget/parse'
import localization from 'widget/MaterialTableOpt'
import { mgyearOpt, exportPdf } from 'views/web/CustomMaterialTable';
import MembersTable from './MembersTable';
import BoardgameTable from './BoardgameTable';

const columns = () => ([
  { width: 80, title: '貨物狀態', field: 'cargoStatus' },
  { width: 80, title: '總價', field: 'totalPrice' },
  { width: 80, title: '實收', field: 'paid' },
  { width: 80, title: '買者', field: 'buyer' },
  { width: 80, title: '聯絡電話', field: 'contactNum' },
  { width: 80, title: '備註', field: 'ps' }
]);
const orderStatusOpt = [
  { text: '報價中', value: '1', key: '1' },
  { text: '訂單成立 撿貨中', value: '2', key: '2' },
  { text: '撿貨完成 出貨中', value: '3', key: '3' },
  { text: '部分產品 已出貨', value: '4', key: '4' },
  { text: '所有產品 已出貨', value: '5', key: '5' },
  { text: '收到物品 已完成(已自取)', value: '6', key: '6' },
  { text: '已取消', value: '7', key: '7' },
]
const opt = { '1': '報價中', '2': '訂單成立 撿貨中', '3': '撿貨完成 出貨中', '4': '部分產品 已出貨', '5': '所有產品 已出貨', '6': '收到物品 已完成(已自取)', '7': '已取消' }
const d = new Date()
class CrewWarehouse extends Component {
  state = {
    activeItem: 'bio',
    data: [],
    monthSel: String(d.getMonth() + 1),
    mgyearSel: String(d.getFullYear() - 1911),
    rowData: {},
    memberObj: {},
    boardgameObj: {},
    boardgameArr: [],
    boardgameArr2: [],
    warehouseObj: {},
    warehouseArr: [],
    gameDeposit: 0,
    cargoStatus: '-1'
  }
  componentDidMount = () => {
    this.handleFetch()
  }
  handleFetch = async () => {
    const { companyObj } = this.props
    const { monthSel, mgyearSel } = this.state
    const companyId = companyObj.objectId
    console.log(monthSel);
    console.log(mgyearSel);
    const data1 = await Parse.queryData('warehouse', { companyId });

    this.setState({ dataArr: data1 })
  }
  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  handleClickName = (rowData, type) => {
    const { boardgameArr, gameDeposit } = this.state
    if (type === 'member') {
      this.setState({ memberObj: rowData })
    } else {
      boardgameArr.push(rowData)

      const number = gameDeposit + Number(rowData.gameDeposit)
      this.setState({ boardgameArr, gameDeposit: number })
    }

  }
  handleChange1 = (e, item) => {
    const { name, value } = e.target
    const { boardgameArr2 } = this.state
    boardgameArr2.push({ ...item, [name]: value })
    this.setState({ boardgameArr2 })
  }
  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value })
  }
  saveWarehouse = async () => {
    const { companyObj } = this.props
    const { memberObj, cargoStatus, boardgameArr2, ps, paid } = this.state
    let total = 0
    boardgameArr2.forEach(item => {
      total += total + Number(item.number) * Number(item.price)
    })
    let obj = {
      companyId: companyObj.objectId,
      buyer: memberObj.name,
      contactNum: memberObj.cellnum,
      cargoStatus: opt[cargoStatus],
      totalPrice: String(total),
      paid: paid,
      ps: ps
    }
    console.log(obj);
    await Parse.saveData('warehouse', obj);
    this.handleFetch()
  }
  handleUpdate = async () => {
    const { newData } = this.state;
    await Parse.saveData('warehouse', newData);
  }

  handleDelete = async () => {
    const { oldData } = this.state
    await Parse.deleteData('warehouse', oldData);
    this.setState({ oldData: {} })
  }

  render() {
    const { companyObj } = this.props
    const { dataArr, boardgameArr, gameDeposit, memberObj, cargoStatus, number, ps, paid } = this.state
    // console.log(rowData);
    return (<div className="content">
      <Header as='h2' inverted={companyObj.inverted}>出售</Header>
      <Row style={{ backgroundColor: '#fff' }}>
        <Col md='6'>
          <h4>1.選擇會員</h4>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>會員類別</Table.HeaderCell>
                <Table.HeaderCell>姓名</Table.HeaderCell>
                <Table.HeaderCell>手機</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>{memberObj.memberType}</Table.Cell>
                <Table.Cell>{memberObj.name}</Table.Cell>
                <Table.Cell>{memberObj.cellnum}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table >
          <br />
          <h4>2.輸入桌遊條碼</h4>
          {/* <Form>
              <Form.Group widths='equal' inline>
                <Form.Input fluid />
                <Form.Button content='Submit' />
              </Form.Group>
            </Form> */}
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>遊戲名</Table.HeaderCell>
                <Table.HeaderCell>售價</Table.HeaderCell>
                <Table.HeaderCell>數量</Table.HeaderCell>
                <Table.HeaderCell>備貨流程</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {boardgameArr.map(item =>
                <Table.Row>
                  <Table.Cell>{item.name}</Table.Cell>
                  <Table.Cell>{item.price}</Table.Cell>
                  <Table.Cell>
                    <Form.Input name='number' value={number} onChange={e => this.handleChange1(e, item)} />
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table >
          <br />
          <h4>3.收取押金：NTD. {gameDeposit}</h4>
          <Form>
            <Form.Group >
              <Form.Select width={8} label='訂單狀況' name='cargoStatus' value={cargoStatus} options={[{ key: 'aa', value: '-1', text: '請選擇' }].concat(orderStatusOpt)} onChange={this.handleChange} />
              <Form.Input width={8} label='實收金額/訂金' name='paid' value={paid} onChange={this.handleChange} />
            </Form.Group>
            <Form.Group >
              <Form.Input width={8} label='備註' name='ps' value={ps} onChange={this.handleChange} />
            </Form.Group>
            <br />
            <Form.Button color='blue' content='確認出售' onClick={this.saveWarehouse} />
          </Form>
        </Col>
        <Col md='6'>
          <MembersTable {...this.props} handleClickName={this.handleClickName} />
          <BoardgameTable {...this.props} handleClickName={this.handleClickName} />
        </Col>
      </Row>
      <br />
      <br />
      <MaterialTable
        localization={localization()}
        columns={columns()}
        options={{
          addRowPosition: "first",
          exportButton: true,
          exportPdf: (columns, data) => exportPdf(columns, data, '出售'),
          pageSize: 10,
          search: false
        }}
        data={dataArr}
        title="出售"
        // actions={[
        //   {
        //     icon: 'view_headline',
        //     tooltip: '查看',
        //     onClick: (event, rowData) => this.handleData(rowData)
        //   }
        // ]}
        editable={{
          // onRowAdd: newData =>
          //   new Promise((resolve, reject) => {
          //     const data = [...dataArr];
          //     data.push(newData);
          //     // handleState('people0', data);
          //     this.setState({ dataArr: data, newData }, () => resolve());
          //   }).then(() => this.handleAdd(0, 0)),
          onRowUpdate: (newData, oldData) =>
            new Promise((resolve, reject) => {
              const data = [...dataArr];
              const index = data.indexOf(oldData);
              data[index] = newData;
              // handleState('people0', data);
              this.setState({ dataArr: data, newData, oldData }, () => resolve());
            }).then(() => this.handleUpdate(0)),
          onRowDelete: oldData =>
            new Promise((resolve, reject) => {
              let data = [...dataArr];
              const index = data.indexOf(oldData);
              data.splice(index, 1);
              // handleState('people0', data);
              this.setState({ dataArr: data, oldData }, () => resolve());
            }).then(() => this.handleDelete(0)),
        }}
      />

    </div >);
  }
}

export default CrewWarehouse;